import { useBulkDelete } from '@/shared/lib';
import { membersApi } from '@/entities/Branch';

export function useMemberDelete(
  selectedCount: () => number,
  selectedMembersArray: () => number[],
  onDeleteSuccess: (deletedIds: number[]) => void,
  removeFromSelection: (ids: number[]) => void,
  onModalClose?: () => void
) {
  return useBulkDelete<{ id: number }>({
    entityName: {
      singular: 'membro',
      plural: 'membros',
    },
    bulkDeleteApi: membersApi.bulkDelete.bind(membersApi),
    onDeleteSuccess,
    removeFromSelection,
    selectedCount,
    selectedIds: selectedMembersArray,
    onModalClose,
  });
}
